import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; // URLパラメータを取得するために追加
import { collection, addDoc, onSnapshot } from "firebase/firestore";
import db from "./firebase_config";

let p5Instance = null;
function Mediaart() {
    const location = useLocation(); // URLからパラメータを取得
    const queryParams = new URLSearchParams(location.search);
    const scriptFile = queryParams.get('script') || 'basic1.js'; // デフォルトは basic1.js

    // 背景色を管理する状態
    const [backgroundColor, setBackgroundColor] = useState('#e0e0e0');

    // 背景色を管理する状態
    const [textColor, settextolor] = useState('#000000');

    useEffect(() => {
        // 時間帯に応じて背景色を設定
        const updateBackgroundColor = () => {
            const currentHour = new Date().getHours();
            settextolor("#000000");
            if (currentHour >= 6 && currentHour < 12) {
                setBackgroundColor('#FFFAE3'); // 朝: 薄い黄色
            } else if (currentHour >= 12 && currentHour < 16) {
                setBackgroundColor('#FFFFFF'); // 昼: 白
            } else if (currentHour >= 16 && currentHour < 19) {
                setBackgroundColor('#FFDAB9'); // 夕方: 薄いオレンジ
            } else {
                setBackgroundColor('#2C3E50'); // 夜: 紺色
                settextolor("#FFFFFF");
            }
        };

        // 初回実行
        updateBackgroundColor();

        // 1時間ごとに背景色を更新
        const interval = setInterval(updateBackgroundColor, 60 * 60 * 1000);

        return () => clearInterval(interval); // クリーンアップ
    }, []);

    useEffect(() => {
        // ページ遷移時に画面のトップにスクロール
        window.scrollTo(0, 0);
    }, [location]);

    // links 配列を定義
    const links = [
        { script: 'basic1.js', id: "basic1", text: 'ランダムパーティクル', detail: 'これは画用紙に触れるとパーティクルが出ます✨\n1. 画用紙をタッチしてください！\n2. そうするといっぱいパーティクルが出てきます!' },
        { script: 'basic2.js', id: "basic2", text: 'インクスロー', detail: 'これは画用紙に触れるとインク投げ体験ができます🎨\n1. 画用紙をタッチしてください！\n2. そうするとインク投げれます! \n3.埋まるくらい投げてみましょう！' },
        { script: 'basic3.js', id: "basic3", text: 'ホイールスピン', detail: 'これは画用紙に触れるとボールとスピンするボールが出てきます！\n1. 画用紙をタッチしてください！\n2. そうするとスピンしているボールが出てきます！' },
        { script: 'basic4.js', id: "basic4", text: 'サウンドウォール', detail: 'これは音声キャッチしてボールがバウンドします！\n1. マイクをオンにしてください🎤\n2. そうすると音量でボールが移動します！\n※マイクの機能はスマートフォン限定です。予めご了承ください。' },
        // { script: 'basic5.js', text: 'サウンドウォール2', detail: 'これは壁の変形を楽しみながらあそべます！✨\n1. マイクをオンにしてください🎤\n2. そうすると音量でボールが移動します！\n3. さらにバウンドすると色が変わるとともに壁が変形します！\n※マイクの機能はスマートフォン限定です。予めご了承ください。' },
        { script: 'basic6.js', id: "basic6", text: 'バウンドショット！！！', detail: 'これはアートに触れるとボールが出てきます✨\n1. アートをタッチしてください！\n2. そうするとボールがタッチした部分に応じて移動します!\n3. 左右別々のエリアで色が変わります！\n4. さらに2つのボールが衝突するとパーティクルが出ます！' },
        { script: 'basic7.js', id: "basic7", text: '桜クション！', detail: 'これは桜の花びらに触れると吹っ飛びます✨\n1.桜の花びらをタッチしてください！\n2. そうすると桜の花びらが吹っ飛びます!' },
        { script: 'basic9.js', id: "basic9", text: 'Gazing Balls', detail: 'これは目の動きでボールが反応します✨\n1.カメラをオンにしてください！\n2. そうすると目の動きでボールが反応します!' },
    ];

    // scriptFile に基づいてタイトルを設定
    const [title, setTitle] = useState('');
    const [id, setid] = useState('');
    const [detail, setDetail] = useState('');
    const [content, setContent] = useState("");
    const [color, setColor] = useState('#ffffff');


    useEffect(() => {
        // scriptFile に基づいてタイトルを設定
        const link = links.find((link) => link.script === scriptFile);
        if (link) {
            setTitle(link.text);
            setDetail(link.detail || '詳細情報がありません');
            setid(link.id);

        } else {
            setTitle('未定義の作品');
            setDetail('詳細情報がありません');
        }
    }, [scriptFile, links]);

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            if (content.length > 0 && content.length <= 20) {
                await addDoc(collection(db, id), {
                    content: content,
                    created_at: new Date().getTime(),
                    color: color || '#ffffff' // デフォルトの色を設定
                });
                setContent('')
                setColor('#ffffff');
            } else {
                alert('1文字以上20文字以下で入力してください。');

            }

        } catch (error) {
            console.log(error);
        }
    };

    const [posts, setPosts] = useState([]);

    useEffect(() => {
        if (!id) return; // idがまだ空なら何もしない

        const unsubscribe = onSnapshot(collection(db, id), (posts) => {
            setPosts(
                posts.docs.map((post) => post.data()).sort((a, b) => b.created_at - a.created_at)
            );
        });

        return () => unsubscribe(); // クリーンアップ
    }, [id]); // idが変更されたときにのみ実行


    const getStrTime = (time) => {
        let t = new Date(time);
        return (`${t.getFullYear()}/${t.getMonth() + 1}/${t.getDate()} ${t.getHours()}:${t.getMinutes()}`);
    }

    useEffect(() => {


        const initializeSketch = () => {
            const container = document.getElementById('p5-container');
            if (window.sketch && container && !p5Instance) {
                p5Instance = new window.p5(window.sketch, container);
            }
        };

        const loadScript = () => {
            // 既存の同一IDのスクリプトを削除（重複防止）
            const existingScript = document.getElementById('p5-script');
            if (existingScript) {
                existingScript.remove();
            }

            const script = document.createElement('script');
            script.id = 'p5-script';
            script.src = `/mediaarts/${scriptFile}`; // 動的にスクリプトパスを設定
            script.async = true;
            document.body.appendChild(script);

            script.onload = () => {
                initializeSketch();
            };

            script.onerror = () => {
                console.error(`Failed to load script: ${scriptFile}`);
            };
        };

        loadScript();

        // クリーンアップ
        return () => {
            if (p5Instance) {
                p5Instance.remove();
                p5Instance = null;
            }
        };
    }, [scriptFile]); // scriptFile が変更されたときに再実行

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!content) return;

        // Firebaseへの投稿（色も含める）
        onSubmit({ content, color });
        setContent('');
        setColor('#ffffff');
    };


    return (
        <div style={{ height: '100%', padding: '0', margin: '0', backgroundColor: backgroundColor }}>
            <h1 style={{ color: textColor, padding: '20px' }}>{title}</h1>
            <p style={{ whiteSpace: 'pre-line', color: textColor, padding: '0 20px' }}>{detail}</p>
            <h2 style={{ color: textColor, padding: '0 20px' }}>作品に触れてみてください！</h2>
            <div id="p5-container" style={{ height: '100%', width: '100%' }}></div>
            <h2>こんな感想が来ました！</h2>
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px',
                marginTop: '1em',
                justifyContent: 'center',
            }}>

                {posts.map((post) => (
                    <div className='post'>
                        <div
                            className="post"
                            style={{
                                width: '150px',
                                height: '150px',
                                backgroundColor: post.color || '#f0f0f0',
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                padding: '10px',
                                boxSizing: 'border-box',
                                wordBreak: 'break-word',
                            }}
                        >
                            <div className="content">{post.content}</div>
                            <div className="created_at">{getStrTime(post.created_at)}</div>
                        </div>
                    </div>
                ))}
            </div>
            <h2 style={{ color: textColor, padding: '0 20px' }}>感想を書いてみてください！</h2>
            <div>
                <form onSubmit={onSubmit}>
                    <input type="text"
                        value={content}
                        placeholder='感想'
                        onChange={(e) => setContent(e.target.value)}></input>
                    <input
                        type="color"
                        value={color}
                        onChange={(e) => setColor(e.target.value)}
                        title="カードの背景色を選んでください"
                    />
                    <button type="submit">投稿</button>

                </form>
            </div>

            {/* <div style={{ marginTop: '20px' }}>
                <button onClick={saveScreenshot} style={{ marginTop: '20px', padding: '10px 20px' }}>
                    スクリーンショットを保存
                </button>
            </div> */}

        </div >
    );
}

export default Mediaart;